module.exports = __webpack_public_path__ + "img/高良姜.02d86c61.jpg";